import dayjs from 'dayjs';

// The ETL titles a month's report October_2026_<awo>_Report.pdf, and a regenerated one
// October_2026_v2_<awo>_Report.pdf, so the month comes from the title: a report regenerated
// later is still that month's. Reports without a title fall back to the month before they were made.
const TITLE_MONTH = /^([A-Z][a-z]+)_(\d{4})_(?:v(\d+)_)?/;

export default function reportLabel(
  { documentTitle, dateCreated }: { documentTitle?: string | null, dateCreated: string },
) {
  const match = documentTitle?.match(TITLE_MONTH);
  const month = match ? `${match[1]} ${match[2]}` : dayjs(dateCreated).subtract(1, 'day').format('MMMM YYYY');
  const version = match?.[3] ? ` (version ${match[3]})` : '';
  return `Monthly Engagement Report - ${month}${version}`;
}
